import { NavigationMenuContent } from '@/components/NavigationMenu';
import { CtaLink } from '@/components/NewHeader/CtaLink';
import {
  CloseButton,
  DataList,
  PromotionalOffersList,
} from '@/components/NewHeader/NavBar/helperComponents';
import { useTranslation } from '@/contexts/dictionaryContext';
import useGTMEvents from '@/hooks/useGTMEvents';
import { usePromotionalCatalogs } from '@/hooks/usePromotionalCatalogs';

export function VillasInPuglia() {
  const {
    newHeader: { villasInPuglia, nav },
  } = useTranslation();
  const { puglia } = usePromotionalCatalogs();
  const promotionalCatalogs = puglia;

  const { sendMenuClickEvent } = useGTMEvents();

  const section =
    nav.find((item) => item.id === 'villas-in-puglia')?.title ||
    'Villas in Puglia';
  const offersTitle =
    nav.find((item) => item.id === 'offers')?.title || 'Offers';

  return (
    <NavigationMenuContent className="w-full xl:w-fit left-0 xl:-right-[25%] 2xl:-right-[15%]">
      <div className="grid grid-cols-[3fr_3fr_2fr] pr-20 gap-4">
        <div className="py-12 pl-20 space-y-6">
          <p className="uppercase font-bold">
            {villasInPuglia.byDestination.title}
          </p>
          <div className="grid grid-cols-1 gap-y-6">
            {villasInPuglia.byDestination.items.map((list) => (
              <DataList
                key={list.title}
                data={list}
                onItemClick={(item) =>
                  sendMenuClickEvent({ section, sectionItem: item.title })
                }
              />
            ))}
          </div>
          <CtaLink
            onClick={() =>
              sendMenuClickEvent({
                section,
                sectionItem: villasInPuglia.cta.title,
              })
            }
            href={villasInPuglia.cta.href}
            className="w-fit">
            {villasInPuglia.cta.title}
          </CtaLink>
        </div>
        <div className="py-12 pl-16">
          <DataList
            onItemClick={(item) =>
              sendMenuClickEvent({ section, sectionItem: item.title })
            }
            data={villasInPuglia.byArea}
            smallContainer
          />
        </div>
        <div className="py-12 space-y-6">
          <DataList
            onItemClick={(item) =>
              sendMenuClickEvent({ section, sectionItem: item.title })
            }
            data={villasInPuglia.byType}
            smallContainer
          />
          <PromotionalOffersList
            title={offersTitle}
            items={promotionalCatalogs}
            onItemClick={(item) =>
              sendMenuClickEvent({ section, sectionItem: item.title })
            }
          />
        </div>
      </div>

      <div className="flex justify-center pb-2">
        <CloseButton />
      </div>
    </NavigationMenuContent>
  );
}
